import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ShopContext } from '../../context/shopContext';
import cross from '../assets/x-solid.svg'; // Import close icon
import userLoggedIn from '../assets/user-solid.svg';
import userLoggedOut from '../assets/user-regular.svg';
import favsIcon from '../assets/heart-white.svg';
import bag from '../assets/bag-shopping-solid.svg';
import './burgerMenu.css';

const BurgerMenu = ({ isOpen, onClose }) => {
    const { cartItems, favourites, accountData } = useContext(ShopContext);
    if (!isOpen) return null; // Prevents rendering when menu is closed


    const cartCounter = cartItems?.length || 0;
    const favs = favourites?.length || 0;
    const isLoggedIn = Boolean(localStorage.getItem("Bearer"));

    return (
        <div className="burger-menu-overlay" onClick={onClose}>
            {/* Prevent clicks inside the menu from closing it */}
            <div className="burger-menu-content" onClick={(e) => e.stopPropagation()}>
                <button className="close-btn" onClick={onClose}>
                    <img src={cross} alt="Close" />
                </button>
                <div className='burger-icon-container'>
                    <div className='icon-container'>
                        {isLoggedIn ? (
                            <div className='icon-container'>
                                <Link to="/account">
                                    <img src={userLoggedIn} className="icons" alt="User" />
                                    <p>Hi, {accountData?.user?.name || "User"}</p>
                                </Link>
                            </div>
                        ) : (
                            <div className='icon-container'>
                                <Link to="/login">
                                    <img src={userLoggedOut} className="icons" alt="Login" />
                                    <p>Login</p>
                                </Link>
                            </div>
                        )}
                    </div>
                    <div className='icon-container'>
                        <div className="burger-cart-count">{favs}</div>
                        <Link to="/favourites">
                            <img src={favsIcon} className="icons" alt="Favourites" />
                            <p>Saved</p>
                        </Link>
                    </div>
                    <div className='icon-container'>
                        <div className="burger-cart-count">{cartCounter}</div>
                        <Link to="/cart">
                            <img className="icons" src={bag} alt="Cart" />
                            <p>Basket</p>
                        </Link>
                    </div>
                </div>
                <nav>
                    <ul>
                        <li><Link to="/all" onClick={onClose}>Shop All Cards</Link></li>
                        <li><Link to="/birthday" onClick={onClose}>Birthday</Link></li>
                        <li><Link to="/engagement" onClick={onClose}>Engagement</Link></li>
                        <li><Link to="/wedding" onClick={onClose}>Wedding</Link></li>
                    </ul>
                </nav>
            </div>
        </div>
    );
};

export default BurgerMenu;
